export default __webpack_public_path__ + "static/media/winding-road.d685d287.svg";